var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.5139 56.5238L74.9362 69.4564C73.6196 74.2135 68.5093 74.8478 66.0288 70.6049L53.3276 48.8832L42.2362 66.0329C39.8619 69.7015 35.1425 69.7255 32.7442 66.0672L27.6802 58.3358L25.3608 60.7135C23.3893 62.7364 20.2351 63.5541 17.4836 62.8958V72.2078C17.4836 76.3872 19.7345 78.5164 23.7511 78.5164H72.2876C76.2648 78.5164 78.5156 76.3872 78.5156 72.2078L78.5139 56.5238ZM78.5139 30.8095V23.7946C78.5139 19.6152 76.2648 17.4861 72.2876 17.4861H23.7511C19.7345 17.4861 17.4836 19.6152 17.4836 23.7946V55.4575L18.9579 56.1844C19.3231 56.3627 20.1665 56.2187 20.4528 55.9255L23.3602 52.9427C26.2128 50.0164 30.7145 50.4535 32.9533 53.8718L37.4722 60.7684L48.7316 43.3615C51.1488 39.6244 55.9196 39.7272 58.1671 43.5724L69.5825 63.0947L78.5139 30.8095ZM23.6328 84.9861C15.2756 84.9861 11.0156 80.8478 11.0156 72.5318V23.4689C11.0156 15.1529 15.2756 11.0146 23.6328 11.0146H72.4093C80.8076 11.0146 84.9853 15.1924 84.9853 23.4689V72.5318C84.9853 80.8084 80.8076 84.9861 72.4093 84.9861H23.6328Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.11645b1ad731d34e484daddbd234cf35.svg";
export { ForwardRef as ReactComponent };